import { Link } from "react-router-dom";
import { projects } from "../constants";
import { arrow } from "../assets/icons";
import "../styles/projects.scss";

const Projects = () => {
  return (
    <section className="projects-container">
      <h1 className="headline">
        <span className="gradient-text">Projects</span>
      </h1>

      {/* <p className="projects-description">
      Each of my case studies is grounded in real-world experience, showcasing problems I’ve encountered and solutions I’ve designed.
      </p> */}

      <div className="project-grid">
        {projects.map((project) => (
          <div className="project-card" key={project.name}>
            <div className={`project-image ${project.theme}`}>
              <img src={project.iconUrl} alt={project.name} className="project-icon" />
            </div>

            <div className="project-info">
              <h4 className="project-title">{project.name}</h4>
              <p className="tech-used">Technologies: {project.Technologies}</p>
              <p className="project-description">{project.description}</p>

              <div className="project-link">
                <Link
                  to={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="live-link"
                >
                  Live Link
                </Link>
                <img src={arrow} alt="arrow icon" className="arrow-icon" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <hr className="divider" />
    </section>
  );
};

export default Projects;
